import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface UpdateMetricConfigurationParams {
    metricLuid: string;
    metricConfiguration: string;
}
export class UpdateMetricConfigurationRequest extends Request<UpdateMetricConfigurationParams, IResult> {
  constructor(params: UpdateMetricConfigurationParams) {
    super('updateMetricConfiguration', params);
  }
}
